<template>
    <section>
        <div class="modal-card" style="width: 1280px; max-width: 100%;">
            <header class="modal-card-head">
                <p class="modal-card-title">Composición Por Año Publicaciones en Revista</p>
                <button type="button" class="delete" @click="$emit('close')" />
            </header>
            <section class="modal-card-body">
                <div class="columns is-centered">
                    <div class="column">

                        <b-table :data="composition" :paginated="true" per-page="10" striped hoverable
                            :pagination-simple="false" pagination-active-color="hsl(0, 0%, 0%)"
                            pagination-position="bottom" default-sort-direction="asc" sort-icon="arrow-up"
                            aria-next-label="Siguiente" aria-previous-label="Anterior" aria-page-label="Página"
                            aria-current-label="Página actual">

                            <b-table-column field="title" label="Nombre Título" sortable searchable>
                                <template #searchable="props">
                                    <b-input v-model="props.filters[props.column.field]" placeholder="Buscar Título..."
                                        icon="search" />
                                </template>
                                <template v-slot="props">
                                    {{ props.row.title }}
                                </template>
                            </b-table-column>

                            <b-table-column field="participants_references" label="Participantes" sortable searchable>
                                <template #searchable="props">
                                    <b-input v-model="props.filters[props.column.field]" placeholder="Buscar Participantes..."
                                        icon="search" />
                                </template>
                                <template v-slot="props">
                                    {{ props.row.participants_references }}
                                </template>
                            </b-table-column>

                            <b-table-column field="publication_date" label="Fecha de Publicación" sortable searchable
                                :custom-search="searchCustomPublicationDate">
                                <template #searchable="props">
                                    <b-input v-model="props.filters[props.column.field]"
                                        placeholder="Buscar Fecha de Publicación..." icon="search" />
                                </template>
                                <template v-slot="props">
                                    {{ props.row.publication_date._isValid ? new Date(props.row.publication_date).toLocaleDateString("es-CL") : '' }}
                                </template>
                            </b-table-column>

                            <b-table-column field="id" width="100" label="Acciones" v-slot="props" size="is-small">
                                <b-button pack="fas" icon-right="eye" type="is-info" tag="a"
                                    :href="/publications/ + props.row.id" target="_blank" />
                            </b-table-column>

                        </b-table>

                    </div>
                </div>

            </section>

            <footer class="modal-card-foot">
                <b-button label="Cerrar" @click="$emit('close')" />
            </footer>

        </div>
        <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false" />
    </section>
</template>

<script>
import axios from 'axios'
import moment from "moment"
import {searchDate} from "../../packs/utilities"
export default {

    name: 'modal_composition_by_year_publication',

    props: [
        'minYear', 'maxYear', 'unitId',
    ],

    data() {
        return{
            isLoading: false,
            composition: [],
        }
    },

    async created() {
        await this.getCompositionFing32()
    },

    methods: {

        async getCompositionFing32() {
            this.isLoading = true
            await axios
                .get('/dashboards/get-indicator-composition-for-unit.json', {
                    params: {
                        unit_id: this.unitId,
                        minYear: this.minYear,
                        maxYear: this.maxYear,
                        indicator_code: 'fing32',
                    }
                })
                .then(response => {
                    this.composition = response.data

                    this.composition.forEach(publication => { 
                        var newPublication = publication
                        newPublication.publication_date = moment(newPublication.publication_date, ["YYYY-MM-DD","DD-MM-YYYY"])
                        return newPublication
                    })
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al obtener los datos. Intente más tarde.',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                }).finally(() => {
                    this.isLoading = false
                })
        },


        searchCustomPublicationDate (row, input) {
            return searchDate (row.publication_date, input)
        },

    },

}
</script>